import './App.css';

function App() {
  return (
    <div>
      <header>
        <h1>Kavitha Grocery Store</h1>
        <p>Your Neighborhood's Freshest Choice!</p>
      </header>

      <div class="hero">
        <div>Fresh. Local. Affordable.</div>
      </div>

      <div class="content">
        <h2>Welcome to Fresh Basket!</h2>
        <p>We provide handpicked fruits, vegetables, and essentials—delivered fresh to your doorstep.</p>

        <div class="quotes">
          <p>🛒 "Small prices. Big convenience."</p>
          <p>🥕 "Freshness you can taste, quality you can trust."</p>
          <p>🧼 "From morning coffee to midnight snacks - we've got your back."</p>
        </div>
      </div>

      <footer>&copy; 2026 Kavitha Grocery Store </footer>
    </div>
  );
}

export default App;
